// @mui

import { GetVisitById } from 'woofwoof-api';
import VisitModalDetailsTabs from './VisitModalDetailsTabs';

// ---------------------------------------------------------------------

type VisitModalDetailsTabProps = {
  visit?: GetVisitById;
};

export default function VisitModalDetailsTab({
  visit,
}: VisitModalDetailsTabProps) {
  if (!visit) {
    return null;
  }

  return <VisitModalDetailsTabs visit={visit} />;
}
